import React from 'react';
import { motion } from 'framer-motion';
import { Quote } from 'lucide-react';
export function TestimonialSection() {
  const testimonials = [{
    quote: "I used to panic every time we went to the ER. Last week I handed the doctor my Snapshot page and she said, 'I wish every parent had this.' The relief was instant.",
    author: 'Sarah M.',
    context: 'Mom of 2, asthma + allergies'
  }, {
    quote: 'My husband usually calls me 10 times during appointments asking for details. With the binder, he just grabbed it and handled the entire specialist visit on his own.',
    author: 'Jessica T.',
    context: 'Mom of 3, complex medical needs'
  }, {
    quote: "I didn't think I needed this because I have notes on my phone. But when my son spiked a fever at 2AM, having the paper checklist kept me calm. Worth every penny.",
    author: 'Elena R.',
    context: 'First-time mom'
  }];
  return <section className="w-full py-20 px-6 bg-warm-white border-t border-soft-sage/20" data-id="element-305">
      <div className="max-w-6xl mx-auto" data-id="element-306">
        <motion.div initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} className="text-center mb-16" data-id="element-307">
          <h2 className="text-3xl md:text-4xl font-bold text-navy font-serif" data-id="element-308">
            Moms who stopped winging it
          </h2>
        </motion.div>

        <div className="grid md:grid-cols-3 gap-8" data-id="element-309">
          {testimonials.map((t, i) => <motion.div key={i} initial={{
          opacity: 0,
          y: 20
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true
        }} transition={{
          delay: i * 0.1
        }} className="bg-white p-8 rounded-xl shadow-sm border border-soft-sage/30 relative flex flex-col h-full" data-id="element-310">
              <Quote className="w-8 h-8 text-teal/20 absolute top-6 left-6" data-id="element-311" />
              <p className="text-body italic text-lg mb-6 relative z-10 pt-4 flex-grow" data-id="element-312">
                "{t.quote}"
              </p>
              <div className="border-t border-soft-sage/20 pt-4 mt-auto" data-id="element-313">
                <p className="font-bold text-navy" data-id="element-314">{t.author}</p>
                <p className="text-sm text-muted" data-id="element-315">{t.context}</p>
              </div>
            </motion.div>)}
        </div>
      </div>
    </section>;
}